import React from 'react';
import { ResponsiveImage, ResponsiveImageSize } from 'react-responsive-image';
import TrackingPixel from './TrackingPixel.jsx';

class Advertisement extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'Advertisement';


    // Amount of pixels the element should be displayed
    // before being scrolled into view
    this.lazyLoadOffset = 200;


    // initial state object
    this.state = {
      show: !this.props.lazy,
    };


    // bind functions to component
    this.renderImage = this.renderImage.bind(this);
    this.onClick = this.onClick.bind(this);
  }


  /**
   * Called when component updates
   * @returns {undefined} undefined
   */
  componentDidUpdate() {
    if (this.props.lazy && typeof window !== 'undefined') {
      const bounds = this.node.getBoundingClientRect();

      if (bounds.top < (window.innerHeight + this.lazyLoadOffset) &&
        bounds.bottom > (0 - this.lazyLoadOffset) &&
        !this.state.show) {
        this.setState({ show: true });
      }
    }
  }


  /**
   * Renders image
   * @returns {ReactElement} React element
   */
  renderImage() {
    const data = this.props.data;
    let element;

    if (this.state.show) {
      element = (
        <ResponsiveImage
          alt={data.alt || 'Bleacher Report'}
        >
          <ResponsiveImageSize
            default
            minWidth={0}
            path={data.small_assets.small}
          />
          <ResponsiveImageSize
            minWidth={300}
            path={data.small_assets.large}
          />
          <ResponsiveImageSize
            minWidth={768}
            path={data.large_assets.large}
          />
          <ResponsiveImageSize
            minWidth={1100}
            path={data.large_assets.largest}
          />
        </ResponsiveImage>
      );
    }

    return element;
  }


  /**
   * Click handler
   * @returns {undefined} undefined
   */
  onClick() {
    const data = this.props.data;

    if (typeof window !== 'undefined') {
      window.location.href = data.clickthrough_url;
    }
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const data = this.props.data;
    const image = this.renderImage();
    const className = 'component-advertisement section-' +
      this.props.iteration + '-' + data.id + ' prev-section-type-' +
      this.props.prevSectionType;

    return (
      <section className={className}>
        <div
          className='ad-image-wrapper'
          onClick={this.onClick}
        >
          <TrackingPixel
            trackingPixelUrl={data.tracking_pixel_url}
          />
          {image}
        </div>
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - The element data
 * @prop {Number} iteration - The iteration of the element
 * @prop {Boolean} lazy - If the component should only display when scrolled
 * into view
 * @prop {String} prevSectionType - The type of the previous section
 */
Advertisement.propTypes = {
  data: React.PropTypes.object,
  iteration: React.PropTypes.number,
  lazy: React.PropTypes.bool,
  prevSectionType: React.PropTypes.string,
};


export default Advertisement;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/Advertisement.jsx
 **/